import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { asyncEligible } from 'config';
import { ProviderConfigList } from 'config/providers';
import { RatePartnerTheme } from 'config/themes';

export const RatePartner: MultiProviderConfig = {
  name: 'RatePartner',
  displayName: 'Rate',
  micrositeCode: 'ratepartner',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://rate.updater.com',
  title: 'Compare and shop for internet & TV with Rate Insurance',
  fallbackPhoneNumber: '844-709-2013',
  fallbackLeadModePhoneNumber: '844-718-8730',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: RatePartnerTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'RatePartner',
  noOffersRetry: 2,
  enableMicrositeLanding: true,
  qualOnLoad: {
    hostname: 'rate.updater.com',
    promoId: '5002473',
  },
  //TVI-1976: Suppress EarthLink and TDS
  providers: ProviderConfigList.filter(
    (provider) =>
      provider.providerCode !== 'earthlink' && provider.providerCode !== 'tds'
  ),
  getCheckoutType: asyncEligible,
  movingAppBuyflowUrls: {
    development: 'http://bridgevine.io:3000/guest/tvi/buy',
    staging: 'https://staging-rate.updater.com/guest/tvi/buy',
    qa: 'https://staging-rate.updater.com/guest/tvi/buy',
    production: 'https://rate.updater.com/guest/tvi/buy',
  },
};
